import './index.css';

import * as Sentry from '@sentry/browser';
import React from 'react';
import { createRoot } from 'react-dom/client';

import { App } from 'app/app';
import { dropSentryNoise } from 'app/shared/sentry/sentry.filters';
import reportWebVitals from './reportWebVitals';

if (!window.Sentry && process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    release: process.env.REACT_APP_VERSION,
    beforeSend: dropSentryNoise,
  });
}

window.Sentry ??= Sentry;

const renderApp = () => {
  const root = createRoot(document.getElementById('root') as HTMLElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
};

const bootstrap = async () => {
  // Start the MSW service worker before React mounts so the very first
  // request fired by TanStack Query is intercepted. Gated by env var so
  // production builds don't pay the worker registration cost.
  if (process.env.REACT_APP_USE_MOCKS === 'true') {
    const { worker } = await import('app/data/mocks/browser');
    await worker.start({
      onUnhandledRequest: 'bypass',
      serviceWorker: { url: '/mockServiceWorker.js' },
    });
  }
  renderApp();
};

bootstrap();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
